import menuRoute from './menuRoute';
import Login from '@/views/Login';
import Layout from '@/views/Layout';
import NotFound from '@/views/NotFound';
import ServerExp from '@/views/ServerExp';
import NoPerm from '@/views/NoPerm';
import QualificationHelp from '@/views/QualificationHelp';

let isHistoryApi = !!(window.history && history.pushState);

export default {
  mode: isHistoryApi ? 'history' : 'hash',
  linkActiveClass: 'is-active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      name: 'Login',
      path: '/login',
      component: Login,
    },
    {
      name: 'Home',
      path: '/',
      component: Layout,
    },
    {
      name: 'NotFound',
      path: '/404',
      component: NotFound,
      // component: () => import('@/views/xxx') // lazy load
    },
    {
      name: 'ServerExp',
      path: '/server-exp',
      component: ServerExp,
    },
    {
      path: '/no-permission',
      component: Layout,
      redirect: '/',
      children: [
        {
          name: 'NoPermission',
          path: '/',
          component: NoPerm,
        },
      ],
    },
    {
      path: '/help',
      component: Layout,
      meta: {
        label: '帮助',
      },
      children: [
        {
          name: 'QualificationHelp',
          meta: {
            label: '资质说明',
          },
          path: 'qualification',
          component: QualificationHelp,
        },
      ],
    },
    /* menu routes */
    ...menuRoute,
    /* */
    {
      path: '*',
      redirect: '/404',
    },
  ],
};
